<template>
    <div>
        <vButton v-if="alltype!='query'" class="margin-top-15 margin-left-15" theme="primary" @click="addItem">{{$t("global.common.add",{defaultValue:'添加'})}}</vButton>
        <vTable
            class="margin-15"
            :columns="shipmentcolumns" 
            :data="shipmentformList"
            size="small" 
            ref="tablequery"  
            border
        ></vTable>
    </div>
</template>

<script>
import { HttpGetStates } from '@/service/boss/b2corder'
import { HttpGetContry } from '@/service/boss/dictionary'
export default {
    props:['shipdata','alltype','allcountries'],
    data(){
        return {
            shipmentformList:[],
            states:[],
            shipflag:1
        }
    },
    computed:{
        shipmentcolumns(){
            let _this = this
            let arrlist = [
                // 1
                {
                    key: 'contact',
                    renderHeader:(h,params)=>{
                        if(_this.alltype=='query' ){
                            return h('div',[
                                h('strong',this.$t("erp.b2border.linkman",{defaultValue:'联系人'}))
                            ])
                        }else{
                            return h('div',[
                                h('Icon',{
                                    props:{
                                        type:"ios-medical",
                                        color:"#ed3f14"
                                    },
                                }),
                                h('strong',this.$t("erp.b2border.linkman",{defaultValue:'联系人'}))
                            ])
                        }
                    },
                    render(h, { row,index }) {
                        if(row.$Edit){
                            return h('Input',{
                                props: {
                                    size:'small',
                                    value:row.contact
                                },
                                on: {
                                    'input':(event) => {
                                        row.contact = event
                                        _this.shipmentformList[index] = row
                                    }
                                },
                            })
                        }else{
                            return <div>
                            {row.contact}
                            </div>
                        }
                    }
                }, 
                // 6
                {
                    key: 'countryCode',
                    renderHeader:(h,params)=>{
                        if(_this.alltype=='query' ){
                            return h('div',[
                                h('strong',this.$tc("global.common.country",1,{defaultValue:'国家'}))
                            ])
                        }else{
                            return h('div',[
                                h('Icon',{
                                    props:{
                                        type:"ios-medical",
                                        color:"#ed3f14"
                                    },
                                }),
                                h('strong',this.$tc("global.common.country",1,{defaultValue:'国家'}))
                            ])
                        }
                    },
                    render(h, { row,index }) {
                        if(row.$Edit){
                            return h('vSelect',{
                                props:{
                                    transfer:true,
                                    filterable:true,
                                    value: row.countryCode,
                                },
                                on: {
                                    'on-change':(value) => {
                                        _this.shipmentformList[index].countryCode = value
                                        _this.oneCountry(value)
                                    }
                                },
                            },
                            _this.allcountries.map((item)=>{
                                return h('vOption', {
                                    props: {
                                        value: item.code,
                                        label: item.code +' (' + item.nameEn +')'
                                    }
                                });
                            }))
                        }else{
                            return <div>
                            {row.countryCode}
                            </div>
                        }
                    }
                }, 
                // 5
                {
                    key: 'state',
                    renderHeader:(h,params)=>{
                        if(_this.alltype=='query' ){
                            return h('div',[
                                h('strong',this.$t("erp.b2c.state_province",{defaultValue:'州/省份'}))
                            ])
                        }else{
                            return h('div',[
                                h('Icon',{
                                    props:{
                                        type:"ios-medical",
                                        color:"#ed3f14"
                                    },
                                }),
                                h('strong',this.$t("erp.b2c.state_province",{defaultValue:'州/省份'}))
                            ])
                        }
                    },
                    render(h, { row,index }) {
                        if(row.$Edit){
                            return h('AutoComplete',{
                                props:{
                                    transfer:true,
                                    filterable:true,
                                    data:_this.states,
                                    'filter-method':_this.filterMethod,
                                    value:row.state,
                                },
                                on: {
                                    'input':(event) => {
                                        row.state = event
                                        _this.shipmentformList[index] = row
                                    }
                                },
                                
                            },)
                        }else{
                            return <div>
                            {row.state}
                            </div>
                        }
                    }
                }, 
                // 4
                {
                    key: 'city',
                    renderHeader:(h,params)=>{
                        if(_this.alltype=='query' ){
                            return h('div',[
                                h('strong',this.$t("erp.b2c.city",{defaultValue:'城市'}))
                            ])
                        }else{
                            return h('div',[
                                h('Icon',{
                                    props:{
                                        type:"ios-medical",
                                        color:"#ed3f14"
                                    },
                                }),
                                h('strong',this.$t("erp.b2c.city",{defaultValue:'城市'}))
                            ])
                        }
                    },
                    render(h, { row,index }) {
                        if(row.$Edit){
                            return h('Input',{
                                props: {
                                    size:'small',
                                    value:row.city
                                },
                                on: {
                                    'input':(event) => {
                                        row.city = event
                                        _this.shipmentformList[index] = row
                                    }
                                },
                            })
                        }else{
                            return <div>
                            {row.city}
                            </div>
                        }
                    }
                }, 
                
                // 2
                {
                    key: 'address1',
                    renderHeader:(h,params)=>{
                        if(_this.alltype=='query' ){
                            return h('div',[
                                h('strong',this.$t("erp.b2border.addressone",{defaultValue:'地址1'}))
                            ])
                        }else{
                            return h('div',[
                                h('Icon',{
                                    props:{
                                        type:"ios-medical",
                                        color:"#ed3f14"
                                    },
                                }),
                                h('strong',this.$t("erp.b2border.addressone",{defaultValue:'地址1'}))
                            ])
                        }
                    },
                    render(h, { row,index }) {
                        if(row.$Edit){
                            return h('Input',{
                                props: {
                                    size:'small',
                                    value:row.address1
                                },
                                on: {
                                    'input':(event) => {
                                        row.address1 = event
                                        _this.shipmentformList[index] = row
                                    }
                                },
                            })
                        }else{
                            return <div>
                            {row.address1}
                            </div>
                        }
                    }
                }, 
                // 3
                {   
                    title: this.$t("erp.b2border.addresstwo",{defaultValue:'地址2'}),
                    key: 'address2',
                    render(h, { row,index }) {
                        if(row.$Edit){
                            return h('Input',{
                                props: {
                                    size:'small',
                                    value:row.address2
                                },
                                on: {
                                    'input':(event) => {
                                        row.address2 = event
                                        _this.shipmentformList[index] = row
                                    }
                                },
                            })
                        }else{
                            return <div>
                            {row.address2}
                            </div>
                        }
                    }
                }, 
                
                // 7
                {
                    key: 'postalCode',
                    renderHeader:(h,params)=>{
                        if(_this.alltype=='query' ){
                            return h('div',[
                                h('strong',this.$t("erp.b2c.zip_code",{defaultValue:'邮编'}))
                            ])
                        }else{
                            return h('div',[
                                h('Icon',{
                                    props:{
                                        type:"ios-medical",
                                        color:"#ed3f14"
                                    },
                                }),
                                h('strong',this.$t("erp.b2c.zip_code",{defaultValue:'邮编'}))
                            ])
                        }
                    },
                    render(h, { row,index }) {
                        if(row.$Edit){
                            return h('Input',{
                                props: {
                                    size:'small',
                                    value:row.postalCode
                                },
                                on: {
                                    'input':(event) => {
                                        row.postalCode = event
                                        _this.shipmentformList[index] = row
                                    }
                                },
                            })
                        }else{
                            return <div>
                            {row.postalCode}
                            </div>
                        }
                    }
                }, 
                // 8
                {
                    key: 'phone',
                    renderHeader:(h,params)=>{
                        if(_this.alltype=='query' ){
                            return h('div',[
                                h('strong',this.$t("erp.b2c.phone",{defaultValue:'电话'}))
                            ])
                        }else{
                            return h('div',[
                                h('Icon',{
                                    props:{
                                        type:"ios-medical",
                                        color:"#ed3f14"
                                    },
                                }),
                                h('strong',this.$t("erp.b2c.phone",{defaultValue:'电话'}))
                            ])
                        }
                    },
                    render(h, { row,index }) {
                        if(row.$Edit){
                            return h('Input',{
                                props: {
                                    size:'small',
                                    value:row.phone
                                },
                                on: {
                                    'input':(event) => {
                                        row.phone = event
                                        _this.shipmentformList[index] = row
                                    }
                                },
                            })
                        }else{
                            return <div>
                            {row.phone}
                            </div>
                        }
                    }
                }, 

                {
                    title: this.$t("erp.b2border.emergency_phone",{defaultValue:'紧急电话'}),
                    key: 'emPhone',
                    render(h, { row,index }) {
                        if(row.$Edit){
                            return h('Input',{
                                props: {
                                    size:'small',
                                    value:row.emPhone
                                },
                                on: {
                                    'input': (event) => {
                                        row.emPhone = event
                                        _this.shipmentformList[index] = row
                                    }
                                },
                            })
                        }else{
                            return <div>{row.emPhone}</div>
                        }
                    }
                },
                {
                    title: this.$t("erp.b2border.fax",{defaultValue:'传真'}),
                    key: 'fax',
                    render(h, { row,index }) {
                        if(row.$Edit){
                            return h('Input',{
                                props: {
                                    size:'small',
                                    value:row.fax
                                },
                                on: {
                                    'input': (event) => {
                                        row.fax = event
                                        _this.shipmentformList[index] = row
                                    }
                                },
                            })
                        }else{
                            return <div>{row.fax}</div>
                        }
                    }
                },
                {
                    title: this.$t("global.common.operation",{defaultValue:'操作'}),
                    width:140,
                    render(h, { row, index }) {
                        if(row.isDefault == 'Y'){
                            return h('div',[
                                h('Button', {
                                    props:{
                                        type:"error",
                                        size:'small',
                                    },
                                    on: {
                                        click: () => {
                                            _this.comremove(index)
                                        }
                                    }
                                },this.$t("global.common.delete",{defaultValue:'删除'}))
                            ])
                        }else{
                            return h('div',[
                                h('Button', {
                                    props:{
                                        type:"primary",
                                        size:'small',
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            _this.changeshipDefault(index)
                                        }
                                    }
                                },this.$t("global.common.set_default",{defaultValue:'设为默认'})),
                                h('Button', {
                                    props:{
                                        type:"error",
                                        size:'small',
                                        disabled:_this.alltype == 'query'
                                    },
                                    on: {
                                        click: () => {
                                            _this.comremove(index)
                                        }
                                    }
                                },this.$t("global.common.delete",{defaultValue:'删除'}))
                            ])
                        }
                    }
                },
            ];
            if(this.alltype =='query'){
                arrlist.splice(10,1)
                let data = {
                    title:this.$t("erp.b2border.isdefault",{defaultValue:'是否默认'}),
                    // key:'isDefault',
                    render(h,{row,index}){
                        switch(row.isDefault){
                            case 'Y':return this.$t("erp.global.yes",{defaultValue:'是'});break;
                            case 'N':return this.$t("erp.global.no",{defaultValue:'否'});break;
                        }
                    }
                }
                arrlist.splice(11,1,data)
                return arrlist
            }else{
                return arrlist
            }
        },
    },
    methods:{
        addItem(){
            let data = {
                type:'SHIP_TO',
                $Edit:true,
                contact:'',
                countryCode:'',
                state:'',
                city:'',
                address1:'',
                address2:'',
                postalCode:'',
                phone:'',
                emPhone:'',
                fax:'',
                isDefault:'N',
            }
            // 新增对象并且加入到数组中
            this.shipmentformList.push(data)
        },
        oneCountry(code,type){
            HttpGetContry({
                "search[EQ_depth]":2,
                "search[EQ_code]":code
            }).then(res=>{
                let onecode = res.data[0]
                this.getStates(onecode.id,type)
            },err=>{

            })
        },
        filterMethod (value, option) {
            return option.toLowerCase().indexOf(value.toLowerCase()) !== -1;
        },
        getStates(codeid){
            this.states = []
            HttpGetStates({
                "search[EQ_depth]":4,
                "search[EQ_parentId]":codeid
            }).then(res=>{
                let array = res.data
                array.map(item=>{
                    this.states.push(item.code)
                })
                // console.log(this.states)
            },err=>{

            })
        },
        changeshipDefault(dataindex){
            this.shipmentformList.map((item,index)=>{
                if(dataindex != index){
                    this.shipmentformList[index].isDefault = 'N';
                }else{
                    this.shipmentformList[index].isDefault = 'Y';
                }
            })

        },
        comremove(index){
            this.shipmentformList.splice(index,1)
        }
    },
    watch:{
        shipdata:{
            deep:true,
            handler(val){
                if(this.shipflag == 1){
                    this.shipdata.map(item=>{
                        if(item.type=='SHIP_TO'){
                            if(this.alltype != 'query'){
                                item.$Edit = true
                            }
                            this.shipmentformList.push(item)
                        }
                    })
                    this.shipflag = 2
                }
            }
        },
    },
}
</script>